import {PolymerElement, html} from '@polymer/polymer';
import '@polymer/polymer/lib/elements/dom-repeat.js';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {htmlLiteral} from "@polymer/polymer/lib/utils/html-tag";
import {FieldcontainerSharedStylesHTML} from '../shared-styles/field-container.js';

class KeliFieldGroup extends ScopeBinding(PolymerElement) {
  static get template() {
    return html`
${FieldcontainerSharedStylesHTML}
<style>
:host {
  display: flex;
  justify-content: space-between;
}

.region {
  margin: 0 5px;
}

.region:first-of-type {
  margin-left: 0;
}

.region:last-of-type {
  margin-right: 0;
}

::slotted(.input-field),
::slotted(keli-value),
::slotted(keli-inline-section) {
  width: 100%;
  min-height: 40px;
}

${this.columnStyles}
</style>

<dom-repeat items="[[slotDefinition]]">
  <template>
    <div class="region" slot-name$="[[item]]"><slot name="[[item]]"></slot></div>
  </template>
</dom-repeat>`;
  }

  static get columnStyles() {
    const styles = [];
    for (let i = 1; i <= 8; ++i) {
      let word = numberToWords.toWords(i);
      styles.push(`.region[slot-name="${word}"] { flex: var(--keli-field-group-slot-${word}-flex, 1); }`);
    }
    const literal = [styles.join('\n')];
    literal.raw = [styles.join('\n')];
    return htmlLiteral(literal);
  }

  static get is() {
    return 'keli-field-group';
  }

  static get properties() {
    return {
      columns: {type: Number, scopevar: true, observer: 'columnsChanged'},
      containsRegions: {type: Boolean, value: true},
      flex: {type: Array, scopevar: true, observer: 'flexChanged'},
      isRegionElement: {type: Boolean, value: true},
      keliControlTypes: {type: Array, value: ['layout-field-group']},
      slotDefinition: Array
    }
  }

  getWordList(max = 8) {
    const words = [];
    let current = 1;
    while (current <= max) {
      words.push(numberToWords.toWords(current));
      ++current;
    }
    return words;
  }

  columnsChanged(newValue) {
    this.slotDefinition = this.getWordList().slice(0, newValue || 0);
  }

  flexChanged(newValue) {
    const words = this.getWordList();
    if (newValue && Array.isArray(newValue)) {
      let styleObject = {};
      newValue.forEach((value, index) => {
        if (!value) {
          return;
        }
        styleObject[`--keli-field-group-slot-${words[index]}-flex`] = value;
      });
      this.updateStyles(styleObject);
    }
  }
}

customElements.define(KeliFieldGroup.is, KeliFieldGroup);
export {KeliFieldGroup};
